export default {
  buttons: {
    skip: 'Ohita',
    back: 'Takaisin',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
    payment: {
      pending: 'Maksuasi käsitellään parhaillaan...',
      success: '👍 Maksusi käsiteltiin onnistuneesti. Kiitos!',
      error:
        '⁉️Maksusi kanssa oli ongelma, tai käsittely kestää odotettua kauemmin. Yritä päivittää sivu minuutin kuluttua, tai ota muussa tapauksessa yhteyttä tekniseen tukeen.',
    },
  },
};
